import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import type { DeleteSavedViewResponse } from '@responses/saved-views';
import axios from 'axios';

export const deleteSavedView = async (id: string): Promise<DeleteSavedViewResponse> => {
  const networkPayload = await getRequestAuthPayload({ method: 'delete', url: `saved-views/${id}` });
  const response = await axios(networkPayload);
  return response.data;
};
